import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { makeStyles } from "@material-ui/core/styles";

import CalendarIcon from "assets/icons/calendar-color.svg";
import AppButton from "components/CustomButtons/AppButton";
import AppColor from "utilities/AppColor";
import AppSelect from "components/Select/AppSelect";
import { Grid, List, ListItem, ListItemText, ListSubheader, Popper } from "@material-ui/core";
// import moment from "moment";
import { useHistory } from "react-router-dom";
import moment from "moment";
import AppUtil from "utilities/AppUtil";
const offsetLazyload = 100;
const BOOKING_STATUS = {
  'DONE': { color: AppColor.mainBlue },
  'ON_GOING': { color: AppColor.violet },
  'CANCEL': { color: AppColor.red },
  'BOOKED': { color: AppColor.green },
  'WAITING': { color: AppColor.orange },
  'NO_CLOCK_IN': { color: AppColor.yellow },
  'NO_ACCEPTED': { color: AppColor.cinnabar },
  'EXPRESS_INTEREST': { color: AppColor.pink }
};



const CalendarToolbar = (props) => {
  const {
    selectedWeek,
    isJobsPage,
    loadData,
  } = props;
  const { t } = useTranslation();
  const isMobile = AppUtil.mobileAndTabletCheck();
  const history = useHistory();

  const scrollRef = React.useRef();
  const [iconCalendar, setIconCalendar] = useState(null);
  const [iconInformation, setIconInformation] = useState(null);
  const [weekList, setWeekList] = useState([]);
  const [weekListDefault, setWeekListDefault] = useState([]);

  const useStyles = makeStyles(() => ({
    hidden: {
      opacity: 0,
      zIndex: -99,
      position: 'absolute',
    },
    active: {
      backgroundColor: AppColor.mainColor,
    },
    toolbarContainer: {
      width: '100%',
      border: 'solid 1px #d2d2d2',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      margin: '10px 0',
      padding: 5,
    },
    appButton: {
      height: 40,
      minWidth: 40
    },
    calendar: {
      cursor: "pointer",
      width: isMobile ? 30 : 40,
      height: isMobile ? 30 : 40,
      marginRight: isMobile ? 10 :0
    },
    infoIcon: {
      color: AppColor.mainColor,
      cursor: "pointer",
      height: 30,
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    infoToolbar: {
      display: 'flex',
      flexGrow: 1,

    },
    titleToolbar: {
      width: '100%',
      fontWeight: 'bold',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerListInfo: {
      color: '#fff',
      fontWeight: 'bold',
      borderTopLeftRadius: '7px',
      borderTopRightRadius: '7px',
      backgroundColor: AppColor.mainColor,
      top: isMobile ? undefined : 0,
    },
    paperListCalendar: {
      height: 350,
      width: 270,
      border: 'solid 1px #d2d2d2',
      borderRadius: '5px',
      backgroundColor: '#fff',
      zIndex: 10,
      overflowY: 'auto'
    },
    listCalendarIcon: {
      '&:hover': {
        backgroundColor: '#e0f8f1',
      }
    },
    select: {
      minWidth: isMobile ? '50%' : '265px',

    },
    paperListInformation: {
      width: 180,
      border: 'solid 1px #d2d2d2',
      borderRadius: '7px',
      backgroundColor: '#e0f8f1',
      zIndex: 10
    },
    itemListInformation: {
      color: '#000',
      backgroundColor: '#e0f8f1',
    },
    itemBlockColor: {
      width: 25,
      height: 25,
      marginRight: 10,
      '&.BOOKED': {
        border: `solid 1px ${BOOKING_STATUS.BOOKED.color}`,
        borderRadius: '3px',
        backgroundColor: BOOKING_STATUS.BOOKED.color
      },
      '&.ON_GOING': {
        border: `solid 1px ${BOOKING_STATUS.ON_GOING.color}`,
        borderRadius: '3px',
        backgroundColor: BOOKING_STATUS.ON_GOING.color
      },
      '&.CANCEL': {
        border: `solid 1px ${BOOKING_STATUS.CANCEL.color}`,
        borderRadius: '3px',
        backgroundColor: BOOKING_STATUS.CANCEL.color
      },
      '&.DONE': {
        border: `solid 1px ${BOOKING_STATUS.DONE.color}`,
        borderRadius: '3px',
        backgroundColor: BOOKING_STATUS.DONE.color
      },
      '&.WAITING': {
        border: `solid 1px ${BOOKING_STATUS.WAITING.color}`,
        borderRadius: '3px',
        backgroundColor: BOOKING_STATUS.WAITING.color
      },
      '&.NO_CLOCK_IN': {
        border: `solid 1px ${BOOKING_STATUS.NO_CLOCK_IN.color}`,
        borderRadius: '3px',
        backgroundColor: BOOKING_STATUS.NO_CLOCK_IN.color
      },
      '&.NO_ACCEPTED': {
        border: `solid 1px ${BOOKING_STATUS.NO_ACCEPTED.color}`,
        borderRadius: '3px',
        backgroundColor: BOOKING_STATUS.NO_ACCEPTED.color
      },
      '&.EXPRESS_INTEREST': {
        border: `solid 1px ${BOOKING_STATUS.EXPRESS_INTEREST.color}`,
        borderRadius: '3px',
        backgroundColor: BOOKING_STATUS.EXPRESS_INTEREST.color
      },
    },
  }));

  const classes = useStyles();

  const JOB_STATUS_SELECT = [
    {
      value: 'ALL',
      label: t(`jobStatusSelect.ALL`)
    },
    {
      value: 'NOT_DONE',
      label: t(`jobStatusSelect.NOT_DONE`)
    }
  ];

  const handleNextWeek = () => {
    const firstWeekDay = selectedWeek.firstWeekDay.clone().add(7, 'days');
    const lastWeekDay = firstWeekDay.clone().endOf('isoWeek');
    loadData({ page_number: 1, firstWeekDay, lastWeekDay })
  }
  const handlePrevWeek = () => {
    const firstWeekDay = selectedWeek.firstWeekDay.clone().subtract(7, 'days');
    const lastWeekDay = firstWeekDay.clone().endOf('isoWeek');
    loadData({ page_number: 1, firstWeekDay, lastWeekDay })
  }
  const handleThisWeek = () => {
    const firstWeekDay = moment().startOf('isoWeek');
    const lastWeekDay = moment().endOf('isoWeek');
    loadData({ page_number: 1, firstWeekDay, lastWeekDay })
  }
  const handleScrollAddWeek = (event) => {
    const element = event.target;
    if (weekList.length > 0 && element && iconCalendar !== null) {
      const list = [];
      if (element.scrollTop < offsetLazyload) {
        const beginDate = weekList[0].firstWeekDay;
        for (let i = 10; i > 0; i--) {
          const firstWeekDay = beginDate.clone().subtract(i * 7, 'days');
          const lastWeekDay = firstWeekDay.clone().endOf('isoWeek');
          list.push({ firstWeekDay, lastWeekDay });
        }
        setWeekList([...list, ...weekList]);
        element.scrollTop = 480;
      } else if (element.scrollHeight - element.scrollTop - element.clientHeight < offsetLazyload) {
        const beginDate = weekList[weekList.length - 1].firstWeekDay;
        for (let i = 1; i <= 10; i++) {
          const firstWeekDay = beginDate.clone().add(i * 7, 'days');
          const lastWeekDay = firstWeekDay.clone().endOf('isoWeek');
          list.push({ firstWeekDay, lastWeekDay });
        }
        setWeekList([...weekList, ...list]);
      }
    }
  }
  const handleSelectWeek = (item) => {
    loadData({ page_number: 1, ...item });
  }

  const handleSelectStatus = option => {
    let list = ['AVAILABLE', 'ON_GOING', 'DONE']
    if (option) {
      if (option.value !== 'ALL') {
        list = ['AVAILABLE', 'ON_GOING']
      }
      loadData({ page_number: 1, jobStatusList: list });
    } else {
      loadData({ page_number: 1, jobStatusList: list });
    }
  }

  useEffect(() => {
    const handleWindowClick = (event) => {
      if (iconInformation && !iconInformation.contains(event.target)) {
        setIconInformation(null);
      }
      if (iconCalendar && !iconCalendar.contains(event.target)) {
        setIconCalendar(null);
      }
    }
    window.addEventListener("click", handleWindowClick);
    return () => {
      window.removeEventListener("click", handleWindowClick);
    };
  }, [iconCalendar, iconInformation]);
  useEffect(() => {
    if (iconCalendar !== null && scrollRef.current) {
      let element = scrollRef.current;
      if (element) {
        element.scrollTop = (element.scrollHeight - element.clientHeight) / 2;
      }
    }
    if (iconCalendar === null && weekListDefault.length > 0) {
      setWeekList([...weekListDefault]);
    }
  }, [iconCalendar, scrollRef]);
  useEffect(() => {
    const list = [];
    const thisWeek = selectedWeek.firstWeekDay;
    // Create a list of the 10 weeks before the current week
    for (let i = 10; i > 0; i--) {
      const firstWeekDay = thisWeek.clone().subtract(i * 7, 'days');
      const lastWeekDay = firstWeekDay.clone().endOf('isoWeek');
      list.push({ firstWeekDay, lastWeekDay });
    }
    // Add current week
    list.push({ ...selectedWeek });
    // Create a list of 10 weeks after the current week
    for (let i = 1; i <= 10; i++) {
      const firstWeekDay = thisWeek.clone().add(i * 7, 'days');
      const lastWeekDay = firstWeekDay.clone().endOf('isoWeek');
      list.push({ firstWeekDay, lastWeekDay });
    }
    setWeekList(list);
    setWeekListDefault(list);
  }, [selectedWeek]);

  return (
    isMobile ?
      <Grid container spacing={1} className={classes.toolbarContainerMobile}>
          <Grid item style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            {isJobsPage && <AppButton
              className={classes.appButton}
              label={t('button.createJob')}
              onClick={() => history.push('/admin/jobs/create')}
            />}
            <AppButton
              className={classes.appButton}
              label={t('button.thisWeek')}
              onClick={handleThisWeek}
            />
          </Grid>
        <Grid item style={{ width: '100%' }}>
          {/* select status */}
          <div style={{ display: 'flex', width: '100%', marginTop: 10, justifyContent: 'space-between' }}>
            <AppSelect
              name={'jobStatusList'}
              isNotMargin={true}
              placeholder={t("label.status")}
              options={JOB_STATUS_SELECT}
              className={classes.select}
              defaultValue={JOB_STATUS_SELECT[1]}
              onChange={handleSelectStatus}
            />
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                onClick={(event) => setIconCalendar(iconCalendar ? null : event.currentTarget)}
                src={CalendarIcon}
                className={classes.calendar}
              />
              <Popper open={true} anchorEl={iconCalendar} className={!iconCalendar ? classes.hidden : ''}>
                <List id="icon-calendar" ref={scrollRef} component="nav" className={classes.paperListCalendar} onScroll={handleScrollAddWeek}>
                  {
                    weekList && weekList.map((item, index) => {
                      const { firstWeekDay, lastWeekDay } = item;
                      return (
                        <ListItem
                          key={`icon-calendar-${index}`}
                          button
                          onClick={() => handleSelectWeek(item)}
                          className={`${classes.listCalendarIcon} ${firstWeekDay.format('DD/MM/YYYY') === selectedWeek.firstWeekDay.format('DD/MM/YYYY') ? classes.active : ''}`}
                        >
                          <ListItemText primary={`${firstWeekDay.format('DD/MM/YYYY')} - ${lastWeekDay.format('DD/MM/YYYY')}`} />
                        </ListItem>
                      );
                    })
                  }
                </List>
              </Popper>
              <i className="fa fa-info-circle" aria-hidden="true" style={{ fontSize: 30, color: AppColor.mainColor  }} onClick={(event) => setIconInformation(iconInformation ? null : event.currentTarget)} />
              <Popper open={Boolean(iconInformation)} anchorEl={iconInformation}>
                <List
                  component="nav"
                  className={classes.paperListInformation}
                  subheader={
                    <ListSubheader component="div" className={classes.headerListInfo}>
                      {t('label.shiftStatus')}
                    </ListSubheader>
                  }
                >
                  {
                    Object.keys(BOOKING_STATUS).map(key => {
                      return (
                        <ListItem key={`shift-status-${key}`} className={classes.itemListInformation}>
                          <div className={`${classes.itemBlockColor} ${key}`} /> {key === "WAITING" ? t(`bookingStatus.PENDING`) : t(`bookingStatus.${key}`)}
                        </ListItem>
                      );
                    })
                  }
                </List>
              </Popper>
            </div>
          </div>
        </Grid>
        <Grid item style={{ display: 'flex', width: '100%' }}>
          <AppButton className={classes.appButton} onClick={handlePrevWeek} style={{ marginRight: 3, width: 40 }}>
            <ArrowLeftIcon fontSize="large" />
          </AppButton>
          <div className={classes.titleToolbar}>
            <span>
              {`${selectedWeek.firstWeekDay.format('DD MMM')} - ${selectedWeek.lastWeekDay.format('DD MMM YYYY')}`}
            </span>
          </div>
          <AppButton className={classes.appButton} onClick={handleNextWeek} style={{ width: 40 }}>
            <ArrowRightIcon fontSize="large" />
          </AppButton>
        </Grid>
      </Grid>
      : <Grid container spacing={1} justifyContent={'flex-start'} className={classes.toolbarContainer}>
        {
          isJobsPage &&
          <Grid item>
            <AppButton
              className={classes.appButton}
              label={t('button.createJob')}
              onClick={() => history.push('/admin/jobs/create')}
            />
          </Grid>
        }
        <Grid item style={{ display: 'flex' }}>
          <AppButton className={classes.appButton} onClick={handlePrevWeek} style={{ marginRight: 3, width: 40, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}>
            <ArrowLeftIcon fontSize="large" />
          </AppButton>
          <AppButton className={classes.appButton} onClick={handleNextWeek} style={{ width: 40, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}>
            <ArrowRightIcon fontSize="large" />
          </AppButton>
        </Grid>
        <Grid item>
          <AppButton
            className={classes.appButton}
            label={t('button.thisWeek')}
            onClick={handleThisWeek}
          />
        </Grid>
        {/* icon calendar */}
        <Grid item>
          <div>
            <img
              onClick={(event) => setIconCalendar(iconCalendar ? null : event.currentTarget)}
              src={CalendarIcon}
              className={classes.calendar}
            />
            <Popper open={true} anchorEl={iconCalendar} className={!iconCalendar ? classes.hidden : ''}>
              <List id="icon-calendar" ref={scrollRef} component="nav" className={classes.paperListCalendar} onScroll={handleScrollAddWeek}>
                {
                  weekList && weekList.map((item, index) => {
                    const { firstWeekDay, lastWeekDay } = item;
                    return (
                      <ListItem
                        key={`icon-calendar-${index}`}
                        button
                        onClick={() => handleSelectWeek(item)}
                        className={`${classes.listCalendarIcon} ${firstWeekDay.format('DD/MM/YYYY') === selectedWeek.firstWeekDay.format('DD/MM/YYYY') ? classes.active : ''}`}
                      >
                        <ListItemText primary={`${firstWeekDay.format('DD/MM/YYYY')} - ${lastWeekDay.format('DD/MM/YYYY')}`} />
                      </ListItem>
                    );
                  })
                }
              </List>
            </Popper>
          </div>
        </Grid>
        {/* select status */}
        {
          isJobsPage &&
          <Grid item>
            <div style={{ display: 'flex' }}>
              <AppSelect
                name={'jobStatusList'}
                isNotMargin={true}
                placeholder={t("label.status")}
                options={JOB_STATUS_SELECT}
                className={classes.select}
                defaultValue={JOB_STATUS_SELECT[1]}
                onChange={handleSelectStatus}
              />
            </div>
          </Grid>
        }
        {/* title */}
        <Grid item className={classes.infoToolbar}>
          <div className={classes.titleToolbar}>
            <span>
              {`${selectedWeek.firstWeekDay.format('DD MMM')} - ${selectedWeek.lastWeekDay.format('DD MMM YYYY')}`}
            </span>
          </div>
          {/* icon Info */}
          <div className={classes.infoIcon}>
            <i className="fa fa-info-circle" aria-hidden="true" style={{ fontSize: 30 }} onClick={(event) => setIconInformation(iconInformation ? null : event.currentTarget)} />
            <Popper open={Boolean(iconInformation)} anchorEl={iconInformation}>
              <List
                component="nav"
                className={classes.paperListInformation}
                subheader={
                  <ListSubheader component="div" className={classes.headerListInfo}>
                    {t('label.shiftStatus')}
                  </ListSubheader>
                }
              >
                {
                  Object.keys(BOOKING_STATUS).map(key => {
                    return (
                      <ListItem key={`shift-status-${key}`} className={classes.itemListInformation}>
                        <div className={`${classes.itemBlockColor} ${key}`} /> {key === "WAITING" ? t(`bookingStatus.PENDING`) : t(`bookingStatus.${key}`)}
                      </ListItem>
                    );
                  })
                }
              </List>
            </Popper>
          </div>
        </Grid>
      </Grid>
  );
};

CalendarToolbar.propTypes = {
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  loadData: PropTypes.func,
  isJobsPage: PropTypes.bool,
  selectedWeek: PropTypes.any,
  selectedYear: PropTypes.any,
};
export default CalendarToolbar;

